{
  "amount": "المبلغ",
  "available": "المتاح",
  "bots": "البوتات",
  "buyLong": "شراء / لونغ",
  "closePosition": "إغلاق المركز",
  "cost": "التكلفة",
  "cross": "كروس",
  "entryPrice": "سعر الدخول",
  "funding": "التمويل",
  "fundingRate": "معدل التمويل",
  "futuresSettings": "إعدادات العقود",
  "futuresSubtitle": "لوحة تداول العقود المباشرة",
  "futuresTitle": "تداول عقود إكسالت",
  "highVolatility": "تقلب عالي",
  "importantNotice": "تنبيه مهم: سوق عقود إكسالت مباشر",
  "isolated": "معزول",
  "leverage": "الرافعة المالية",
  "limit": "محدد",
  "liquidation": "التصفية",
  "liveFuturesMarket": "سوق العقود مباشر",
  "loading": "جاري التحميل...",
  "lowVolatility": "تقلب منخفض",
  "margin": "الهامش",
  "marginMode": "وضع الهامش",
  "markPrice": "سعر المؤشر",
  "market": "سوق",
  "mobileFuturesChart": "رسم العقود على الهاتف",
  "noClosedPositions": "لا توجد مراكز مغلقة",
  "noOpenPositions": "لا توجد مراكز مفتوحة",
  "normalCandles": "شموع عادية",
  "normalVolatility": "تقلب عادي",
  "openLong": "فتح لونغ",
  "openOrders": "الأوامر المفتوحة",
  "openPositions": "المراكز المفتوحة",
  "openShort": "فتح شورت",
  "orderBook": "دفتر الأوامر",
  "orderType": "نوع الأمر",
  "perpetualFutures": "عقود دائمة",
  "positionHistory": "سجل المراكز",
  "positions": "المراكز",
  "price": "السعر",
  "priceMovementWarning": "قد تكون حركة السعر والسيولة محدودة خارج ساعات التداول المعتادة.",
  "processing": "جاري المعالجة...",
  "quoteCurrency": "عملة التسعير",
  "reduceOnly": "تقليل فقط",
  "riskLevel": "مستوى المخاطر",
  "searchMarket": "ابحث عن السوق...",
  "searchPair": "ابحث عن الزوج...",
  "sellShort": "بيع / شورت",
  "serverError": "خطأ في الخادم.",
  "sessionExpired": "انتهت الجلسة. الرجاء تسجيل الدخول مرة أخرى.",
  "slPrice": "سعر وقف الخسارة",
  "smoothCandles": "شموع سلسة",
  "stopLoss": "وقف الخسارة",
  "takeProfit": "جني الأرباح",
  "tpPrice": "سعر جني الأرباح",
  "tradingViewChart": "رسم TradingView البياني",
  "volatileCandles": "شموع متقلبة",
  "zoomLarge": "تكبير كبير",
  "zoomMedium": "تكبير متوسط",
  "zoomSmall": "تكبير صغير"
}